class AveyLocalizationSelector extends HTMLElement {
  connectedCallback() {
    if (this.form) return;
    this.form = this.querySelector('form');
    if (!this.form) return;
    this.language = this.form.elements.language_code;
    this.country = this.form.elements.country_code;
    this.initialLanguage = this.language?.value;
    this.initialCountry = this.country?.value;
    this.form.addEventListener('submit', this.onSubmit);
    this.country?.addEventListener('change', this.onCountryChange);
    this.addEventListener('click', this.onLanguageClick);
    if (this.language?.tagName === 'SELECT') this.language.hidden = true;
    const choices = this.querySelector('.avey-localization__choices');
    if (choices) choices.hidden = false;
    const apply = this.querySelector('[data-localization-apply]');
    if (apply) apply.hidden = true;
  }

  disconnectedCallback() {
    this.form?.removeEventListener('submit', this.onSubmit);
    this.country?.removeEventListener('change', this.onCountryChange);
    this.removeEventListener('click', this.onLanguageClick);
    this.form = null;
  }

  onSubmit = () => {
    const returnTo = this.form.elements.return_to;
    const target = new URL(window.location.href);
    target.searchParams.delete('country');
    if (returnTo) returnTo.value = target.pathname + target.search;
  };

  onCountryChange = () => this.form.requestSubmit();

  onLanguageClick = (event) => {
    const button = event.target.closest('[data-localization-language-code]');
    if (!button || !this.contains(button) || !this.language) return;
    const code = button.dataset.localizationLanguageCode;
    if (code === this.initialLanguage && this.country?.value === this.initialCountry) return;
    this.language.value = code;
    this.form.requestSubmit();
  };
}

if (!customElements.get('avey-localization-selector')) {
  customElements.define('avey-localization-selector', AveyLocalizationSelector);
}
